const USAGE_MUTABLE_FIELDS = [
  'order_no',
  'producer',
  'farmunit',
  'diversionPoint',
  'ditch',
  'division',
  'user',
  'flow',
  'on_date',
  'on_time',
  'on_notes',
  'off_date',
  'off_time',
  'off_notes',
  'acre_ft',
  'billable_acre_ft',
  'regular_hours',
  'discount_hours',
  'regular_acre_ft',
  'discount_acre_ft',
  'discount_rate',
  'is_discount',
  'waterYear',
  'offline_request_id',
  'flowUpdate',
  'oldUsageId',
  'order_id'
]

const USAGE_MUTABLE_FIELD_SET = new Set(USAGE_MUTABLE_FIELDS)

const hasOwn = (payload, key) => Object.prototype.hasOwnProperty.call(payload, key)

const hasValue = value => value !== null && value !== undefined && value !== ''

export const sanitizeUsagePayload = (payload = {}, { includeWaterYear = true } = {}) => {
  if (!payload || typeof payload !== 'object' || Array.isArray(payload)) {
    return payload
  }

  return Object.keys(payload).reduce((result, key) => {
    if (USAGE_MUTABLE_FIELD_SET.has(key) && (includeWaterYear || key !== 'waterYear')) {
      // order_id must be a real server id — an offline temp uuid would fail the
      // backend exists rule at sync time, so non-numeric values are dropped
      // (the legacy completion path still covers those orders).
      if (key === 'order_id' && !Number.isInteger(Number(payload[key]))) {
        return result
      }
      result[key] = payload[key]
    }

    return result
  }, {})
}

export const sanitizeUsageUpdatePayload = (payload = {}, existing = null, options = {}) => {
  const sanitized = sanitizeUsagePayload(payload, options)

  if (
    sanitized &&
    typeof sanitized === 'object' &&
    !Array.isArray(sanitized) &&
    hasOwn(sanitized, 'off_date') &&
    !hasOwn(sanitized, 'off_time') &&
    hasValue(sanitized.off_date) &&
    hasValue(existing?.off_time)
  ) {
    sanitized.off_time = existing.off_time
  }

  return sanitized
}
